const translations = {
    title: 'Regulamin',
    description: '',
    canonical: 'string',
    image: '',
    robots: 'noindex, nofollow',
};

export default translations;